import { ISkillDetailsAtAGlanceResponse, ISkillDetailsMapSnippetResponse, ISkillDetailsPeopleDrawerParams, ISkillDetailsPeopleDrawerResponse, ISkillDetailsResponse, ISkillRelatedSkillsResponse } from "app/components/DetailsPages/interfaces/skill"
import { http } from "./http"

export const getSkillDetails = (slug: string) => {
  return http.get<ISkillDetailsResponse>(`skill/${slug}/details`)
}

export const getSkillAtAGlance = (slug: string) => {
  return http.get<ISkillDetailsAtAGlanceResponse>(`skill/${slug}/details/at_a_glance`);
}

export const getSkillMapSnippet = (slug: string) => {
  return http.get<ISkillDetailsMapSnippetResponse>(`skill/${slug}/details/map_snippet`);
}

export const getSkillPeopleDrawer = (slug: string, params?: ISkillDetailsPeopleDrawerParams) => {
  return http.get<ISkillDetailsPeopleDrawerResponse>(`skill/${slug}/drawers/people`, params); 
}

export const getSkillRelatedSkills = (slug: string) => {
  return http.get<ISkillRelatedSkillsResponse>(`skill/${slug}/drawers/related_skills`);
}
